module.exports = __webpack_public_path__ + "media/like.1605cec4.mp3";